<ww-grid class="grid-group-by-style" [id]="'riskDashboardGrid'" [gridData]="risks" [columnsHeader]="riskColumns"
    [allowDeleting]="false" [allowUpdating]="false" [height]="'300px'" [enableColumnChooser]="false"
    [filterPanel]="false" [groupable]="false" [enableExport]="false" [searchPanel]="false" [groupingContextMenu]="false"
    [allowAdding]="false" [enableHeaderFilter]="false">
</ww-grid>